<div class="tutorial-button-container" *ngIf="!_tutorialService.force_open_modal">
    <button class="btn btn-primary" (click)="openModal()">{{'OPEN_VIDEO'|translate}}</button>
</div>


<ng-template #tutorialModal let-modal>
    <div id="tutorial-modal" class="position-relative">
        <span class="tutorial-dismiss cursor-pointer" (click)="modal.close();modalClose()">×</span>
        <video controls width="100%" *ngIf="currentVideo.videos && currentVideo.videos.length > 0" autoplay>
            <source [src]="currentVideo.urls[0]" type="video/mp4">
            <source [src]="currentVideo.urls[1]" type="video/ogg">
            <source [src]="currentVideo.urls[2]" type="video/webm">
        </video>
        <p *ngIf="currentVideo.description" class="py-1 px-2 m-0" [innerHTML]="currentVideo.description"></p>
    </div>
</ng-template>